import { cn } from "@gigpro/ui/tailwind/cn";
import React from "react";
import { useLoaderOption } from "./useLoaderOption";

export const EmojiLoader = ({ className, ...props }: React.ComponentProps<"div">) => {
  const [emoji, message] = useLoaderOption();
  return (
    <div className={cn("flex h-full flex-col items-center justify-center overflow-hidden", className)} {...props}>
      <div className="mb-[0.2em] animate-blur-in text-[3em] delay-100">{emoji}</div>
      <div className="animate-blur-in text-huge text-gray">{message}</div>
    </div>
  );
};
